export function useBcAlgoliaData(algoliaData: any, locale: string) {
  const [lang] = locale.split('-');
  const bcAlgoliaData = algoliaData;
  const langName = lang === 'en' ? bcAlgoliaData.name : bcAlgoliaData[`name_${lang}`] || bcAlgoliaData.name;
  bcAlgoliaData.product_offerings.bc_primary_product.product.name = langName;
  // console.log({lang, country});
  return bcAlgoliaData;
}
